import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import RolePermissions from "models/system-admin/role-permissions";
import Role from "models/system-admin/roles";
import { RolesService } from "providers/roles/roles.service";
import { UtilityService } from "providers/utility-service/utility-service";

@Component({
  selector: "view-role-details",
  templateUrl: "view-role-details.html",
})
export class ViewRoleDetails implements OnInit {
  // @Input() companyData: Company;
  @Input() role: Role;
  @Input() isEdit: boolean;

  @Output()
  hideComponent = new EventEmitter<boolean>();

  rolePermissions: RolePermissions[] = [];

  private filterParameters: any = {};
  private permissionFilterParameters: any = {};

  constructor(
    private utilityService: UtilityService,
    private roleService: RolesService
  ) {}

  ngOnInit(): void {
    this.getPermissionsByRole();
  }

  getPermissionsByRole() {
    if (this.role) {
      this.utilityService.increaseSpinnerCount();
      this.loadFilters();

      this.roleService.getUsersRoles(this.filterParameters).subscribe(
        (response) => {
          this.rolePermissions = [];
          if (response && response["hits"]) {
            this.rolePermissions = this.roleService.formatRolePermissions(
              response["hits"]
            );
            // Only expand a group that actually came back. `hits` can be a
            // truthy EMPTY array, in which case rolePermissions[0] is undefined
            // and loadPermissions used to throw AFTER increaseSpinnerCount() —
            // inside the subscribe, so decreaseSpinnerCount() never ran and the
            // user was left stuck behind the full-screen loading overlay.
            if (this.rolePermissions.length > 0) {
              this.loadPermissions(this.rolePermissions[0]);
            }
          }
          this.utilityService.decreaseSpinnerCount();
        },
        (err) => {
          this.utilityService.presentErrorToast(
            err,
            "Error loading Role Permissions."
          );
          this.utilityService.decreaseSpinnerCount();
        }
      );
      // this.utilityService.decreaseSpinnerCount();
    }
  }

  goBack() {
    this.hideComponent.emit(true);
  }

  public onCollapseClicked(rolePermission: RolePermissions): void {
    rolePermission.collapse = !rolePermission.collapse;
    if (rolePermission.collapse) {
      this.loadPermissions(rolePermission);
    }
  }

  loadPermissions(rolePermission: RolePermissions) {
    if (!rolePermission) {
      return;
    }
    this.utilityService.increaseSpinnerCount("Loading permission details...");

    this.loadFilterPermissions(rolePermission);
    this.roleService.getUsersRoles(this.permissionFilterParameters).subscribe(
      (response) => {
        if (response && response["hits"]) {
          rolePermission.permissions = this.roleService.formatPermissions(
            rolePermission.permissions,
            response["hits"]
          );
        }
        this.utilityService.decreaseSpinnerCount();
      },
      (err) => {
        this.utilityService.presentErrorToast(
          err,
          "Error loading Permissions details."
        );
        this.utilityService.decreaseSpinnerCount();
      }
    );
    // this.utilityService.decreaseSpinnerCount();
  }

  public arrowClick(permission: any): void {
    permission.showDetails = !permission.showDetails;
  }

  loadFilters() {
    this.filterParameters.entityType = "ROLEPERMISSIONS";
    this.filterParameters.mustFields = [
      {
        name: "id",
        value: this.role.id,
      },
    ];
  }

  loadFilterPermissions(rolePermission: RolePermissions) {
    this.permissionFilterParameters.entityType = "PERMISSION";
    this.permissionFilterParameters.optionalFields = [];
    this.permissionFilterParameters.from = 0;
    this.permissionFilterParameters.size =
      rolePermission.permissions != null
        ? rolePermission.permissions.length
        : 20;
    (rolePermission.permissions || []).forEach((r) => {
      this.permissionFilterParameters.optionalFields.push({
        name: "name",
        value: r.name,
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/system-admin/view-role-details/view-role-details.ts